module.exports = __webpack_public_path__ + "images/buttons/sf_switchit.gif";